import React, { useState, useEffect } from 'react'
import _ from 'lodash'

import { Icon } from 'pharmacy/src/display/icon'

import TextareaAutosize from 'react-textarea-autosize'

import { useSelector } from 'react-redux'

import classNames from 'classnames'

import css from './headerLlmSearch.scss'

const openSearchPage = (value) => {
  if (!value?.trim() || typeof window === 'undefined') return
  const pathname = window.location.pathname ?? ''
  const pathnameNoIds = pathname.replace(/\/\d+/g, '/:id')
  const params = `query=${encodeURIComponent(
    value
  )}&src=popover-search&src-page=${encodeURIComponent(pathnameNoIds)}`

  window.location.assign(`/v2/search/questions?${params}`)
}

export const HeaderLlmSearch = () => {
  const [searchQuery, setSearchQuery] = useState()
  const [isMultiLine, setIsMultiLine] = useState(false)

  const highlightSearchHeader = useSelector(
    (state) => state.search.highlightSearchHeader
  )

  useEffect(() => {
    const checkWidth = () => {
      if (typeof window !== 'undefined') {
        setIsMultiLine(window.innerWidth < 544)
      }
    }

    // Initial check
    checkWidth()

    // Add resize listener
    typeof window !== 'undefined' &&
      window.addEventListener('resize', checkWidth)

    // Cleanup
    return () => {
      typeof window !== 'undefined' &&
        window.removeEventListener('resize', checkWidth)
    }
  }, [])

  const submitSearch = () => {
    openSearchPage(searchQuery)
  }

  const InputComponent = isMultiLine ? TextareaAutosize : 'input'

  return (
    <div className={css.searchInputOuterContainer}>
      <div className={css.searchInputContainer}>
        <Icon
          className={css.searchIcon}
          icon={['far', 'search']}
          onClick={submitSearch}
        />
        <InputComponent
          className={classNames(css.searchInput, {
            [css.highlightedSearchHeader]: highlightSearchHeader,
          })}
          onChange={(e) => setSearchQuery(e.target.value)}
          value={searchQuery}
          type="text"
          placeholder="Search our Q&A"
          onKeyDown={(event) => {
            event.stopPropagation()
            if (event.key === 'Enter') {
              if (!isMultiLine || !event.shiftKey) {
                event.preventDefault()
                submitSearch()
              }
            }
          }}
          {...(isMultiLine
            ? {
                maxRows: 2,
              }
            : {})}
        />
        {!_.isEmpty(searchQuery) && (
          <Icon
            className={css.clearIcon}
            icon={['far', 'times']}
            onClick={() => setSearchQuery('')}
          />
        )}
      </div>
    </div>
  )
}
